import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { countryToCodeMapping, codeToCountryMapping, pendoTypes } from 'appConstants';
import { userActions } from 'redux/actions';
import { sendMsgToExt } from 'util/messagePassing';
// eslint-disable-next-line id-match
import { outbound } from 'extActions';
import PhoneNumberDetectionComponent from '@icimscorp/mui-acs/build/components/PhoneNumberDetection';
import { track } from 'util/pendo';

const PhoneNumberDetection = () => {
	const dispatch = useDispatch();
	const { user } = useSelector((state) => state);
	const { preferences } = user;
	const { isSwitchOn, preferredPhoneRegions } = preferences;
	const { internalCustomerType } = useSelector((state) => state.user.customer);

	const handleSelectPhoneNumberDetection = (value) => {
		const phoneRegions = value !== 'default' ? [countryToCodeMapping[value]] : [];
		dispatch(userActions.updatePreferredPhoneRegions({ phoneRegions }));
		sendMsgToExt({
			action: outbound.SET_PHONE_NUMBER_DETECTION,
			additionalData: {
				countryCode: phoneRegions.length ? phoneRegions[0] : 'default'
			}
		});
		track(
			pendoTypes.trackPhoneNumberPreference,
			{
				newMatchingPreference: phoneRegions
			},
			internalCustomerType
		);
	};

	return (
		<PhoneNumberDetectionComponent
			data-testid="phoneRegions"
			preferredCountry={
				preferredPhoneRegions.length ? codeToCountryMapping[preferredPhoneRegions[0]] : 'default'
			}
			handleCountrySelectionChange={handleSelectPhoneNumberDetection}
			countrySelectionDisabled={!isSwitchOn}
		/>
	);
};

export default PhoneNumberDetection;
